export function acceptPlusCharInURLString(urlEncodedText: string) {
  // emails with plus signs dont decode well with normal encodeing
  return urlEncodedText.replace(/%20/g, "+");
}
